import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Facebook, Linkedin } from 'lucide-react';
// Custom X (Twitter) icon
const XIcon = ({
  className
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" className={className} fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-1863" data-mp="9tzo61y97ew9">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" data-id="element-1864" data-mp="5uhbftgl6a4i" />
  </svg>;
// YouTube icon
const YouTubeIcon = ({
  className
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" className={className} fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-1865" data-mp="st3tazmocoin">
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" data-id="element-1866" data-mp="oqyzo0w87rw0" />
  </svg>;
interface ShareButtonsProps {
  layout?: 'horizontal' | 'vertical' | 'compact';
  title?: string;
  showLabel?: boolean;
}
export const ShareButtons: React.FC<ShareButtonsProps> = ({
  layout = 'horizontal',
  title = 'Share This Cultural Experience',
  showLabel = true
}) => {
  const eventUrl = typeof window !== 'undefined' ? window.location.href : 'https://sikhkingdoms.com';
  const eventTitle = 'Life in the Sikh Kingdoms - An Immersive Dining Experience';
  const eventDescription = "Step inside Maharaja Ranjit Singh's court for two unforgettable nights of taste, art, music, and history. June 15-16, 2026 in Toronto.";
  const shareLinks = [{
    name: 'WhatsApp',
    icon: MessageCircle,
    url: `https://wa.me/?text=${encodeURIComponent(`${eventTitle}\n\n${eventDescription}\n\n${eventUrl}`)}`
  }, {
    name: 'YouTube',
    icon: YouTubeIcon,
    url: `https://www.youtube.com/@sikhkingdoms`
  }, {
    name: 'Facebook',
    icon: Facebook,
    url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(eventUrl)}`
  }, {
    name: 'LinkedIn',
    icon: Linkedin,
    url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(eventUrl)}`
  }, {
    name: 'X',
    icon: XIcon,
    url: `https://x.com/intent/tweet?text=${encodeURIComponent(eventTitle)}&url=${encodeURIComponent(eventUrl)}`
  }];
  const containerClass = layout === 'horizontal' ? 'flex flex-wrap items-center justify-center gap-4' : layout === 'vertical' ? 'flex flex-col items-center gap-4' : 'flex items-center gap-3';
  return <div className="w-full" data-id="element-1867" data-mp="ks1jsb9e8329">
      {showLabel && <div className="text-center mb-8" data-id="element-1868" data-mp="1hcsbo2045yia">
          <h3 className="font-serif text-2xl text-amber-400 mb-2" data-id="element-1869" data-mp="1hdlewszv65vo">{title}</h3>
          <div className="w-16 h-px bg-amber-400/30 mx-auto" data-id="element-1870" data-mp="1cjqvlqo67sx4"></div>
        </div>}
      <div className={containerClass} data-id="element-1871" data-mp="2v9cy34ue5855">
        {shareLinks.map((link, index) => <motion.a key={link.name} href={link.url} target="_blank" rel="noopener noreferrer" className="group relative" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: index * 0.1
      }} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} aria-label={`Share on ${link.name}`} data-id="element-1872" data-mp="307wk158zijxi" data-mpi={index}>
            <div className="border border-amber-400/30 hover:border-amber-400 bg-black/40 hover:bg-black/60 p-4 transition-all duration-300" data-id="element-1873" data-mp="3rzvranrkt95g">
              <link.icon className="w-5 h-5 text-amber-400" data-id="element-1874" data-mp="5rw4dejw9525" />
            </div>
            <span className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 text-xs text-white/60 opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap font-light" data-id="element-1875" data-mp="3o8zyuz19jl3j">
              {link.name}
            </span>
          </motion.a>)}
      </div>
    </div>;
};